import { Box, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const Header = styled(Box)(({ theme }) => ({
  marginBottom: 10,
}));

const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  lineHeight: '28px',
  fontWeight: 700,
  fontSize: 32,
}));

const Description = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  lineHeight: '18px',
}));

export default function BigCard({ title, description, children }) {
  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: 'primary.contrastText',
        p: 8,
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Header>
        <Title variant='h1'>{title}</Title>
        <Description variant='body2'>{description}</Description>
      </Header>
      <Stack spacing={2} sx={{ alignItems: 'center' }}>
        {children}
      </Stack>
    </Box>
  );
}
